import { APLLoginLayout } from 'onboarding/components/layout/apl/APLLoginLayout'

import { APLLoginForm } from './login/APLLoginForm'

export const APLLoginPage = () => {
  return <APLLoginLayout content={<APLLoginForm />} />
}
